import { render, staticRenderFns } from "./canva_cta_post.vue?vue&type=template&id=f4bdaac2&scoped=true&"
import script from "./canva_cta_post.vue?vue&type=script&lang=js&"
export * from "./canva_cta_post.vue?vue&type=script&lang=js&"
import style0 from "./canva_cta_post.vue?vue&type=style&index=0&id=f4bdaac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bdaac2",
  null
  
)

export default component.exports